import { render, staticRenderFns } from "./TableauManagement.vue?vue&type=template&id=244e9915&scoped=true&"
import script from "./TableauManagement.vue?vue&type=script&lang=js&"
export * from "./TableauManagement.vue?vue&type=script&lang=js&"
import style0 from "./TableauManagement.vue?vue&type=style&index=0&id=244e9915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e9915",
  null
  
)

export default component.exports